// internationalization

// material ui
import { Card, CardContent, Divider, Typography } from '@mui/material';

// api
import { useUnitsGetCollectionAsyncByqueryOptionsQuery } from '@/api/generated/recalc/endpoints/v1/units';

// feature-components
import AlarmTypeCardHeader from '@/features/alarm-hub/components/alarmType/AlarmTypeCardHeader';
import UnitAlarmChart from '@/features/alarm-hub/components/highcharts/UnitAlarmChart';

// feature-hooks
import useUnitData from '@/features/alarm-hub/hooks/useUnitData';

const SeepLeakageDetected = ({ alarm }) => {
  const associatedUnits = alarm?.Associations?.Units || [];

  const { data: units } = useUnitsGetCollectionAsyncByqueryOptionsQuery(
    { 'Account.AccountId': `eq(${alarm?.AccountId})` },
    { skip: !alarm?.AccountId || associatedUnits.length === 0 },
  );

  const unitMatches = units
    ? units.filter((unit) => associatedUnits.some((id) => id === unit.UnitId))
    : [];

  const { chartSeries, isLoading } = useUnitData({
    accountId: alarm?.AccountId,
    selectedUnits: unitMatches,
    dateRange: {
      from: alarm?.DataFrom,
      to: alarm?.DataTo,
    },
    aggregateOverride: 'Minutes5',
  });

  return (
    <Card>
      <AlarmTypeCardHeader alarm={alarm} title="Seep Leakage Detected" />
      <Divider />
      <CardContent>
        <Typography variant="body1">{alarm.Details}</Typography>
      </CardContent>
      <CardContent>
        <UnitAlarmChart
          unitData={chartSeries}
          isLoading={isLoading}
          alarm={alarm}
        />
      </CardContent>
    </Card>
  );
};

export default SeepLeakageDetected;
